import { DatePicker, Input, Table } from "antd";
import React, { Component } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { httpGet, httpUrl } from "../../api/httpClient";
import CoinSelectBox from "../../components/common/CoinSelectBox";
import SelectBox from "../../components/common/SelectBox";
import string from "../../string";
import { amountFormat, formatDate } from "../../util";



const Search = Input.Search;
const { RangePicker } = DatePicker;

class StakingStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchType: string.defaultSearchTypeCode[0],
      searchText: '',
      searchCoinType: 101,
      stakingBalanceList: [],
      pagination: {
        total: 0,
        current: 1
      },
    };
  }

  componentDidMount() {
    this.getStakingBalanceList();
  }
  handleTableChange = (pagination, filters, sorter) => {
    const pager = { ...this.state.pagination };
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    }, ()=>this.getStakingBalanceList());
  };

  initialLoad = () => {
    this.setState({
      stakingBalanceList: [],
      pagination: {
        total: 0,
        current: 1
      }}, () => {
        this.getStakingBalanceList();
      })
  }
  reload = () => {
    this.getStakingBalanceList();
  }
  getStakingBalanceList = () => {
    let pageNum = this.state.pagination.current;
    let userId = '';
    let userName = '';
    let userTel = '';
    if (this.state.searchType == 'ID') userId = this.state.searchText;
    else if (this.state.searchType == 'NAME') userName = this.state.searchText;
    else if (this.state.searchType == 'PHONE') userTel = this.state.searchText;
    httpGet(httpUrl.stakingBalance,[10,pageNum,this.state.searchCoinType,userId, userName, userTel],{}).then((res) => {
      const pagination = { ...this.state.pagination };
      pagination.current = res.data.currentPage;
      pagination.total = res.data.totalCount;
      this.setState({
        stakingBalanceList: res.data.balances,
        pagination,
      });
    });
  };
  render() {
    const { stakingBalanceList } = this.state;
    const coinList = reactLocalStorage.getObject("coinList");
    const columns = [
      {
        title: "아이디",
        dataIndex: "userId",
        className: "support-column-number fs-15 lh-21",
      },
      {
        title: "이름",
        dataIndex: "userName",
        className: "support-column fs-15 lh-21",
      },
      {
        title: "코인종류",
        dataIndex: "coinType",
        className: "support-column fs-15 lh-21",
        render: (data, row) => (coinList.find((coin) => coin.coinType === data).name)
      },
      {
        title: "스테이크 수량",
        dataIndex: "balance",
        className: "support-column-number fs-15 lh-21",
        render: (data, row) => <div>{amountFormat(data, row.coinType) + ' ' + coinList.find((coin) => coin.coinType === row.coinType).symbol}</div>
      },
      {
        title: "스테이크락 수량",
        dataIndex: "lockAmount",
        className: "support-column-number fs-15 lh-21",
        render: (data, row) => <div>{amountFormat(data, row.coinType) + ' ' + coinList.find((coin) => coin.coinType === row.coinType).symbol}</div>
      },
      {
        title: "출금가능 수량",
        dataIndex: "balance",
        className: "support-column-number fs-15 lh-21",
        render: (data, row) => <div>{amountFormat(data-row.lockAmount, row.coinType) + ' ' + coinList.find((coin) => coin.coinType === row.coinType).symbol}</div>
      },

    ];

    return (
      <div>
        <div
          style={{
            fontSize: "20px",
            color: "#000",
            textAlign: "center",
            marginBottom: "30px",
            fontWeight: "bold",
          }}>
          스테이킹 현황
      </div>
        <div className="wrapper mt-35 width-1240" />
          <div className="flex-row flex-center" style={{paddingBottom: '10px'}}>
            <label htmlFor="" style={{ marginRight: "20px" }}>
              코인{" "}
              <CoinSelectBox
                placeholder="선택해주세요."
                value={this.state.searchCoinType}
                exceptERC
                onChange={(value) => {
                  this.setState({searchCoinType: value})
                }}
                style={{ width: "160px" }}
              />
            </label>
            <label htmlFor="searchType">검색 대상&nbsp;</label>
            <SelectBox
              value={this.state.searchType}
              code={string.defaultSearchTypeCode}
              codeString={string.defaultSearchTypeString}
              onChange={(value) => {
                  this.setState({
                    searchType: value,
                  });
              }}
            />
            <Search
              placeholder={`검색어를 입력해주세요.`}
              enterButton="검색"
              allowClear
              onSearch={(value) => {
                this.setState({searchText: value}, ()=>this.reload())
              }}
              style={{ width: 400 }}
            />
          </div>
        <Table
          rowKey={(record) => record.idx}
          rowClassName={(record) => (record.deleted ? "gray" : "")}
          dataSource={stakingBalanceList}
          columns={columns}
          pagination={this.state.pagination}
          onChange={this.handleTableChange}
        />
      </div>
    );
  }
}

export default StakingStatus;
